module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst entityContext = (config || {}).entityContext || 'prompt'\nconst additionalClasses = []\nif(config.usage)        additionalClasses.push(`usage_${config.usage}`);\nif(config.usageMode)    additionalClasses.push(`usageMode_${config.usageMode}`);\nconst tooltips = config.tooltips || {}\n%>\n<div class=\"<%= additionalClasses.join(' '); %>\">\n<section class=\"main\">\n<section class=\"top\">\n<section class=\"left\">\n<h1><%= storage.__(config.titleKey || ''); %></h1>\n</section>\n<section class=\"center\"></section>\n<section class=\"right\">\n<%\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'refresh', context: entityContext, symbolOnly: false } }); %><%\nif(config.usage !== 'selection'){\n%><%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: entityContext, symbolOnly: false, positive: true } }); %><%\n}\n%>\n</section>\n</section>\n<%\nif(tooltips.NW){\n%><%- include('../../../base/tooltip/tooltip', { model: tooltips.NW }); %><%\n}\n%>\n<section class=\"bottom\">\n<%- helpers.renderSection('filter'); %>\n<%- helpers.renderSection('list'); %>\n</section>\n</section>\n<%- helpers.renderSection('selection'); %>\n</div>"
  , __filename = "components/templates/mblx/prompts/controller.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const entityContext = (config || {}).entityContext || 'prompt'
const additionalClasses = []
if(config.usage)        additionalClasses.push(`usage_${config.usage}`);
if(config.usageMode)    additionalClasses.push(`usageMode_${config.usageMode}`);
const tooltips = config.tooltips || {}

    ; __line = 7
    ; __append("\n<div class=\"")
    ; __line = 8
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">\n<section class=\"main\">\n<section class=\"top\">\n<section class=\"left\">\n<h1>")
    ; __line = 12
    ; __append(escapeFn( storage.__(config.titleKey || '') ))
    ; __append("</h1>\n</section>\n<section class=\"center\"></section>\n<section class=\"right\">\n")
    ; __line = 16
    ; 

    ; __line = 17
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'refresh', context: entityContext, symbolOnly: false } }) )
    ; 
if(config.usage !== 'selection'){

    ; __line = 19
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: entityContext, symbolOnly: false, positive: true } }) )
    ; 
}

    ; __line = 21
    ; __append("\n</section>\n</section>\n")
    ; __line = 24
    ; 
if(tooltips.NW){

    ; __line = 26
    ; __append( include('../../../base/tooltip/tooltip', { model: tooltips.NW }) )
    ; 
}

    ; __line = 28
    ; __append("\n<section class=\"bottom\">\n")
    ; __line = 30
    ; __append( helpers.renderSection('filter') )
    ; __append("\n")
    ; __line = 31
    ; __append( helpers.renderSection('list') )
    ; __append("\n</section>\n</section>\n")
    ; __line = 34
    ; __append( helpers.renderSection('selection') )
    ; __append("\n</div>")
    ; __line = 35
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/mblx/prompts/controller.ejs

}